import {connect} from 'react-redux';
import Form_6 from './Form_6';
import {submitStep} from '../../actions/steps/submitStep';
import {getShumaStepStatus} from '../../actions/steps/getShumaStepStatus';
import {showGlobalErrorMessage} from 'common/actions/globalErrorMessage/showGlobalErrorMessage';
import {uploadFile} from '../../actions/files/uploadFile';
import {getStepData} from '../../actions/steps/getStepData';
import {getFileList} from '../../actions/files/getFileList';

const mapStateToProps = ({
                           step11FileList: {list: filesListData},
                           stepData: {stepData},
                           shumaProperties: {shumaTypeID}
                         }) => ({
  stepData,
  shumaTypeID,
  filesListData
});

export default connect(
  mapStateToProps,
  {
    submitStep,
    uploadFile,
    getShumaStepStatus,
    showGlobalErrorMessage,
    getStepData,
    getFileList
  }
)(Form_6);
